

import React from 'react';
import { connect } from '../../../../../redux/connect';
import {
  getCurrentViewType, getRFIEnum,
} from '../../../../../redux/selectors';
import { toOptionsArray } from "../../../../../utils/parsing-helpers";
import classNames from "classnames";
import { viewTypes } from "../../../../../constants/view-types";
import PropTypes from "prop-types";
import { issueAttributesType } from "../../../../../constants/proptype-validation";
import { ISSUE_ATTRIBUTE_NAMES } from "../../../../../constants/issue-attribute-names";
import LocationDescriptionInlineEdit from "../../../../LocationDescriptionInlineEdit";
import LinkedDocumentInlineEdit from "./LinkedDocumentInlineEdit";

function IssuePreviewDetailsTabLinksSection({ viewType, issue, container }) {
  const divClassNames = classNames('IssuePreviewDetailsTabLinksSection', {
    'IssuePreviewDetailsTabLinksSection__narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabLinksSection__wide': viewType === viewTypes.PROJECT,
  });
  return <form className={divClassNames}>
    <div className="IssuePreviewDetailsTabLinksSection__field-wrapper" >
      <LinkedDocumentInlineEdit
        key={ISSUE_ATTRIBUTE_NAMES.TARGET_URN}
        issue={issue}
        container={container}
        horizontalAlign={true}
      />
    </div>
    <LocationDescriptionInlineEdit
      key={ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION}
      issue={issue}
      horizontalAlign={true}
    />
  </form>;
}

IssuePreviewDetailsTabLinksSection.displayName = 'IssuePreviewDetailsTabLinksSection';

IssuePreviewDetailsTabLinksSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  container: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
  return {
    viewType: getCurrentViewType(state),
    categoryOptions: toOptionsArray(getRFIEnum('category')(state)),
    disciplineOptions: toOptionsArray(getRFIEnum('discipline')(state)),
    priorityOptions: toOptionsArray(getRFIEnum('priority')(state)),
  };
};

export default connect(mapStateToProps)(IssuePreviewDetailsTabLinksSection);
